import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DecaimalnumberDirective } from './decimalnumber.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GooglemapsComponent } from "./../dashboard/googlemaps/googlemaps.component";
import { GooglemapsdxComponent } from "./../dashboard/googlemapsdx/googlemapsdx.component";
import { ThousandseperatorDirective } from './thousandseperator.directive';
import { CommonRecieptComponent } from '../common-components/common-reciept/common-reciept.component';
import { AgmDirectionModule } from 'agm-direction';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../environments/environment';
import { DxDataGridModule, DxLoadPanelModule, DxRadioGroupModule } from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FileUploadModule } from 'ng2-file-upload';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { SalesRoutingModule } from '../../../routes/sales/sales-routing.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AttachmentsComponent } from '../theme/attachments/attachments.component';
import { LoadpopupComponent } from '../theme/expensemanagement/loadpopup/loadpopup.component';
import { CustomerformComponent } from '../theme/customerform/customerform.component';
import { FilteringpopupComponent } from '../common-components/filteringpopup/filteringpopup.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import { GeneratePdfComponent } from './generate-pdf/generate-pdf.component';
import { DriversService } from '../../services/driver.service';
import { ConfirmTimeComponent } from './confirm-time/confirm-time.component';
import { WelcomeLandingPageComponent } from '../dashboard/welcome-landing-page/welcome-landing-page.component';
@NgModule({
    declarations: [
        GooglemapsComponent,
        ThousandseperatorDirective,
        GooglemapsdxComponent,
        DecaimalnumberDirective,
        CommonRecieptComponent,
        AttachmentsComponent,
        LoadpopupComponent,
        CustomerformComponent,
        FilteringpopupComponent,
        GeneratePdfComponent,
        ConfirmTimeComponent
    ],
    imports: [
        CommonModule,
        SalesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule,
        NgSelectModule,
        DxDataGridModule,
        ModalModule.forRoot(),
        MatExpansionModule,
        NgxDocViewerModule,
        // PdfViewerModule,
        MatDialogModule,
        MatStepperModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        FileUploadModule,
        NgxIntlTelInputModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatTooltipModule,
        DxRadioGroupModule,
        DxLoadPanelModule,
        MatCheckboxModule,
        MatCardModule,


        // ThemeModule

        AgmCoreModule.forRoot({
          apiKey: environment.googleAPIKey,
          libraries: ["places"],
      }),
      AgmDirectionModule,
    ],
    providers:[
        GooglemapsdxComponent,
        GooglemapsComponent,
        LoadpopupComponent,
        CommonRecieptComponent,
        CustomerformComponent,
        FilteringpopupComponent,
        DriversService
    ],
    exports: [
        GooglemapsdxComponent,
        GooglemapsComponent,
        ThousandseperatorDirective,
        DecaimalnumberDirective,
        CommonRecieptComponent,
        LoadpopupComponent,
        CustomerformComponent,
    ]
})
export class SharedModule { }
